import React, { useEffect, useState } from 'react';
import CarrierOverview from './CarrierOverview';
import { withStyles } from '@material-ui/core';
import clsx from 'clsx';
import { flowRight } from 'lodash';
import { connect } from 'react-redux';

import styles from '../styles/networkData';
import { translate } from '../../../i18n/I18nProvider';
import CarrierCharacteristics from './CarrierCharacteristics';
import CarrierProducts from './CarrierProducts';
import { isDefined, isUndefined } from '../../../utils/isDefined';

const CarrierData = ({
  fromRightPanel,
  classes,
  carrierData,
  rightPanelData
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (
      (isDefined(carrierData) && !fromRightPanel) ||
      (fromRightPanel && isDefined(rightPanelData))
    ) {
      setOpen(true);
    }
  }, [carrierData, rightPanelData, fromRightPanel]);

  return (
    <div className={classes.root}>
      <div
        className={classes.labelContainer}
        onClick={() => carrierData && (open ? setOpen(false) : setOpen(true))}
      >
        {open ? (
          <i
            className={clsx('fas fa-chevron-down', {
              [classes.hidden]:
                (!fromRightPanel && isUndefined(carrierData)) ||
                (fromRightPanel && isUndefined(rightPanelData))
            })}
            onClick={() => setOpen(false)}
          ></i>
        ) : (
          <i
            className={clsx('fas fa-chevron-right', {
              [classes.hidden]:
                (!fromRightPanel && isUndefined(carrierData)) ||
                (fromRightPanel && isUndefined(rightPanelData))
            })}
            onClick={() => setOpen(true)}
          ></i>
        )}
        <div className={classes.label}>Carrier</div>
      </div>

      {open && (
        <div className={classes.content}>
          <div className={classes.container}>
            <CarrierOverview fromRightPanel={fromRightPanel} />
          </div>
          <div className={classes.container}>
            <CarrierCharacteristics fromRightPanel={fromRightPanel} />
          </div>
          <div className={classes.container}>
            <CarrierProducts fromRightPanel={fromRightPanel} />
          </div>
        </div>
      )}
    </div>
  );
};

const mapStatesToProps = ({ auth, checkNumber, rightPanel }) => {
  return {
    lang: auth.lang,
    carrierData: checkNumber?.carrierData,
    rightPanelData: rightPanel?.number?.carrierData
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(CarrierData);
